// import React from "react";
// import { Typography } from "@material-tailwind/react";
// import { BsFillTelephoneFill, BsFillEnvelopeFill, BsBuildingsFill, BsBuildingFillGear, BsFacebook, BsInstagram, BsYoutube } from "react-icons/bs";


// import Logo from "../../images/logo.png";
// import { Link } from "react-router-dom";


// const Footer = () => {
//     return (
//         <footer className="pb-4 text-white border-t border-primary bg-secondary">
//             <div className="container mx-auto">

//                 <div className="py-8 flex justify-between items-center">
//                     <Link to={"/"} className="flex justify-center items-center px-4 py-1 ">
//                         <img src={Logo} alt="logo footer" className="h-16" />
//                     </Link>

//                     <div className="flex items-center">
//                     </div>
//                 </div>

//                 <div className="grid sm:grid-cols-4 md:grid-cols-6 grid-cols-1 gap-4 pb-8">
//                     <div className="flex flex-col items-start sm:col-span-2 md:col-span-2 col-span-1 sm:mb-0 mb-4">
//                         <div className="flex items-center mb-1">
//                             <BsFillTelephoneFill className="mr-3 text-lg" />
//                             <span className="font-normal text-sm">Tél : +213 (0) 21 44 82 63</span>
//                         </div>
//                         <div className="flex items-center mb-1">
//                             <BsFillEnvelopeFill className="mr-3 text-lg" />
//                             <span className="font-normal text-sm">contact@nasco.dz</span>
//                         </div>
//                         <div className="flex items-center mb-1">
//                             <BsBuildingsFill className="mr-3 text-2xl" />
//                             <span className="font-normal text-sm">Social: Domaine Ouadah BP 8bis Birkhadem, Alger.</span>
//                         </div>
//                     </div>


//                     <div className="flex flex-col sm:col-span-2  md:col-span-2 col-span-1 items-start sm:mb-0 mb-4">
//                         <Typography variant="paragraph" className="font-medium mb-2">
//                             LIENS
//                         </Typography>

//                         <Link to={`/`}>
//                             <Typography
//                                 className={`font-normal text-sm`}
//                             >
//                                 Accueil
//                             </Typography>
//                         </Link>

//                         <Link to={`/about`}>
//                             <Typography
//                                 className={`font-normal text-sm`}
//                             >
//                                 À propos
//                             </Typography>
//                         </Link>

//                         <Link to={`/services`}>
//                             <Typography
//                                 className={`font-normal text-sm`}
//                             >Services

//                             </Typography>
//                         </Link>

//                         <Link to={`/contact`}>
//                             <Typography
//                                 className={`font-normal text-sm`}
//                             >
//                                 Contact
//                             </Typography>
//                         </Link>
//                     </div>


//                     <div className="flex flex-col items-start sm:col-span-2  md:col-span-2 col-span-1 sm:mb-0 mb-4">
//                         <Typography variant="paragraph" className="font-medium mb-2">
//                             NEWSLETTER
//                         </Typography>

//                         <Typography
//                             className={`font-normal text-sm mb-2`}
//                         >
//                             Abonnez-vous pour recevoir toutes les actualités de nos marques.
//                         </Typography>

//                         <div className="w-full flex items-center border border-secondary bg-white">
//                             <input type='email' placeholder='E-mail' className={`px-2 py-1 flex-1 placeholder:font-light  placeholder:text-secondary`} />
//                             <button className="bg-transparent px-2 py-[5px] text-secondary">
//                                 Souscrire
//                             </button>
//                         </div>

//                     </div>

//                 </div>

//                 <hr className="my-3 border-white" />
//                 <p className="text-center">
//                     Copyright &copy; NASCO 2025. Tous droits réservés.
//                 </p>
//             </div>
//         </footer>
//     );
// };

// export default Footer;



import React from "react";
import { Typography } from "@material-tailwind/react";
import { BsFillTelephoneFill, BsFillEnvelopeFill, BsBuildingsFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Logo from "../../images/logo.png";

const Footer = () => {
    const { t, i18n } = useTranslation();

    return (
        <footer className="pb-4 text-white border-t border-primary bg-secondary">
            <div className="container mx-auto">

                <div className="py-8 flex justify-between items-center">
                    <Link to={"/"} className="flex justify-center items-center px-4 py-1">
                        <img src={Logo} alt="logo footer" className="h-16" />
                    </Link>
                </div>

                <div className="grid sm:grid-cols-4 md:grid-cols-6 grid-cols-1 gap-4 pb-8">
                    <div className="flex flex-col items-start sm:col-span-2 md:col-span-2 col-span-1 sm:mb-0 mb-4">
                        <div className="flex items-center mb-1">
                            <BsFillTelephoneFill className={`${i18n.language === "ar" ? 'ml-3' : 'mr-3'} text-lg`} />
                            <span className="font-normal text-sm">{t("footer.phone")}</span>
                        </div>
                        <div className="flex items-center mb-1">
                            <BsFillEnvelopeFill className={`${i18n.language === "ar" ? 'ml-3' : 'mr-3'} text-lg`} />
                            <span className="font-normal text-sm">{t("footer.email")}</span>
                        </div>
                        <div className="flex items-center mb-1">
                            <BsBuildingsFill className={`${i18n.language === "ar" ? 'ml-3' : 'mr-3'} text-2xl`} />
                            <span className="font-normal text-sm">{t("footer.address")}</span>
                        </div>
                    </div>

                    <div className="flex flex-col sm:col-span-2 md:col-span-2 col-span-1 items-start sm:mb-0 mb-4">
                        <Typography variant="paragraph" className="font-medium mb-2">
                            {t("footer.links")}
                        </Typography>

                        <Link to={`/`}>
                            <Typography className="font-normal text-sm">
                                {t("footer.home")}
                            </Typography>
                        </Link>

                        <Link to={`/about`}>
                            <Typography className="font-normal text-sm">
                                {t("footer.about")}
                            </Typography>
                        </Link>

                        <Link to={`/services`}>
                            <Typography className="font-normal text-sm">
                                {t("footer.services")}
                            </Typography>
                        </Link>

                        <Link to={`/contact`}>
                            <Typography className="font-normal text-sm">
                                {t("footer.contact")}
                            </Typography>
                        </Link>
                    </div>

                    <div className="flex flex-col items-start sm:col-span-2 md:col-span-2 col-span-1 sm:mb-0 mb-4">
                        <Typography variant="paragraph" className="font-medium mb-2">
                            {t("footer.newsletter")}
                        </Typography>

                        <Typography className="font-normal text-sm mb-2">
                            {t("footer.subscribeText")}
                        </Typography>

                        <div className="w-full flex items-center border border-secondary bg-white">
                            <input
                                type='email'
                                placeholder={t("footer.emailPlaceholder")}
                                className="px-2 py-1 flex-1 placeholder:font-light placeholder:text-secondary"
                            />
                            <button className="bg-transparent px-2 py-[5px] text-secondary">
                                {t("footer.subscribe")}
                            </button>
                        </div>
                    </div>
                </div>

                <hr className="my-3 border-white" />
                <p className="text-center">
                    {t("footer.copyright")}
                </p>
            </div>
        </footer>
    );
};

export default Footer;
